import { RouteConfig } from '../types/routing.types';
import { dashboardRoutes } from './dashboard/routes';
import { metricsRoutes } from './metrics/routes';
import { organisationRoutes } from './organisation/routes';
import { processusRoutes } from './processus/routes';
import { objectifsRoutes } from './objectifs/routes';
import { contextRoutes } from './context/routes';
import { actionsRoutes } from './actions/routes';
import { ncRoutes } from './nc/routes';

export const featureRoutes: RouteConfig[] = [
  ...dashboardRoutes,
  ...organisationRoutes,
  ...processusRoutes,
  ...objectifsRoutes,
  ...actionsRoutes,
  ...ncRoutes,
  ...contextRoutes,
  ...metricsRoutes,
];
